<template>
  <section id="access" class="access-content-title">
    <!-- タイトル・サブタイトル -->
    <div class="text-wrapper">
      <h1 class="title">{{ $t('page.access.title') }}</h1>
      <div class="sub-title">{{ $t('page.access.sub-title') }}</div>
    </div>

    <!-- GoogleMap -->
    <iframe
      class="google-map"
      :src="googleMapUrl"
      style="border: 0"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    />

    <div class="access-facility-container">
      <!-- アクセス -->
      <div class="access-wrapper">
        <div class="title">{{ $t('page.access.access-title') }}</div>
        <div ref="tabRoot" class="tabs">
          <button class="tab -active" :class="localeClass" @click="onClickTab" v-html="$t('page.access.routes.route-1')"></button>
          <button class="tab" :class="localeClass" @click="onClickTab" v-html="$t('page.access.routes.route-2')"></button>
          <button class="tab" :class="localeClass" @click="onClickTab" v-html="$t('page.access.routes.route-3')"></button>
        </div>

        <!-- 経由切り替えタブ -->
        <div ref="routeRoot" class="routes">
          <div class="route -active">
            <Route1 />
          </div>
          <div class="route">
            <Route2 />
          </div>
          <div class="route">
            <Route3 />
          </div>
        </div>
      </div>

      <!-- 施設情報 -->
      <div class="facility-wrapper">
        <div class="title">{{ $t('page.access.facility-title') }}</div>

        <div class="facility-name">
          <div class="title-name">{{ $t('util.title') }}</div>
          <div class="sub-title-name">{{ $t('util.sub_title') }}</div>
        </div>
        <div class="description">
          <div class="text">{{ $t('util.title_and_sub_title_plus_text1') }}</div>
        </div>

        <!-- アドレス -->
        <div class="address facility-content">
          <div class="content-title">{{ $t('page.facility.address.content-title') }}</div>

          <ul class="list line">
            <li class="item postcode">
              <span class="svg icon" />
              <span class="text">{{ $t('util.post_code') }}</span>
            </li>
            <li class="item address">
              <span class="svg icon" />
              <span class="text">{{ $t('util.company_address') }}</span>
            </li>
            <li class="item contact-number">
              <span class="svg icon" />
              <span class="text">{{ $t('util.telephone_address') }}</span>
            </li>
          </ul>
        </div>

        <!-- チェックイン・アウト -->
        <div class="check-in-out facility-content">
          <div class="content-title" v-html="$t('page.facility.check-in-out.content-title')"></div>

          <ul class="list line">
            <li class="item">
              {{ $t('page.facility.check-in-out.line1') }}
            </li>
            <li class="item">
              {{ $t('page.facility.check-in-out.line2') }}
            </li>
          </ul>
        </div>

        <!-- 部屋数 -->
        <div class="room-num facility-content">
          <div class="content-title">{{ $t('page.facility.room-num.content-title') }}</div>

          <ul class="list">
            <li class="item">
              {{ $t('page.facility.room-num.line1') }}
            </li>
          </ul>
        </div>

        <!-- 支払方法 -->
        <div class="payment-method facility-content">
          <div class="content-title">{{ $t('page.facility.payment-method.content-title') }}</div>

          <ul class="list line">
            <li class="item" v-html="$t('page.facility.payment-method.line1')"></li>
          </ul>
        </div>
        <!-- 駐車場 -->
        <div class="payment-method facility-content">
          <div class="content-title">{{ $t('page.facility.parking-lot.content-title') }}</div>

          <ul class="list line">
            <li class="item" v-html="$t('page.facility.parking-lot.line1')"></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import Route1 from "~/components/uiParts/Routes/Route1.vue";
import Route2 from "~/components/uiParts/Routes/Route2.vue";
import Route3 from "~/components/uiParts/Routes/Route3.vue";

const { locale } = useI18n()
const localeClass = computed(() => `-${locale.value}`)
const googleMapUrl = computed(() => {
  switch (locale.value) {
    case 'en':
      return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3316.1103975906753!2d129.66472539999998!3d33.78364719999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356a158d993e1173%3A0x6be7afc152cba213!2z5aSp5q-U55m76YO9IEFNQUhJVE9UU1U!5e0!3m2!1sen!2sjp!4v1781095240160!5m2!1sen!2sjp';
    default:
      return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4020.181678528042!2d129.66174637923177!3d33.7841872297275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356a158d993e1173%3A0x6be7afc152cba213!2z5aSp5q-U55m76YO9IEFNQUhJVE9UU1U!5e0!3m2!1sja!2sjp!4v1779278044612!5m2!1sja!2sjp';
  }
})
const tabRoot = ref<HTMLElement|null>(null)
const routeRoot = ref<HTMLElement|null>(null)

/**
 * クリックしたタブに切り替える
 */
const onClickTab = (event: MouseEvent) => {
  if (!tabRoot.value) {
    return
  }
  const clickTab = event.target as HTMLElement
  Array.from(tabRoot.value.children).forEach((tab, index) => {
    if (!routeRoot.value) {
      return;
    }
    const route = routeRoot.value.children[index] as HTMLElement;
    if (clickTab === tab) {
      clickTab.classList.add('-active')
      route.classList.add('-active')
      return
    }
    tab.classList.remove('-active')
    route.classList.remove('-active')
  })
}
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#access {
  background: v.$common-white-color;
  padding: 160px 0 80px;
  text-align: center;
  @include m.sp() {
    padding: 64px 0 96px;
  }
}

.text-wrapper {

  .title {
    color: v.$accent-color;
    font-size: 1.125rem;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    margin: 0;
    @include m.sp() {
      font-size: 1rem;
      letter-spacing: 6.4px;
    }
  }

  .sub-title {
    color: v.$text-title-color;
    font-size: 1.375rem;
    line-height: 1.5;
    word-break: keep-all;
    @include m.sp() {
      font-size: 1.25rem;
      letter-spacing: 3px;
    }
  }
}

.google-map {
  margin-top: 100px;
  height: 460px;
  width: 100%;
  -webkit-filter: sepia(0.35);
  filter: sepia(0.35);
  @include m.sp() {
    margin-top: 64px;
    height: 192px;
  }
}

.access-facility-container {
  margin: 136px auto 0;
  padding: 0 3%;
  display: flex;
  max-width: 1276px;
  column-gap: clamp(24px, 2.396vw, 46px);
  justify-content: center;
  @include m.sp() {
    flex-flow: wrap;
    margin: 64px auto 0;
  }

  .title {
    color: v.$text-title-color;
    font-size: 1.5rem;
    height: 80px;
    border-bottom: 1px solid v.$text-title-color;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.3;
    @include m.sp() {
      font-size: 1.25rem;
      height: initial;
      padding-bottom: 16px;
    }
  }

  .access-wrapper {
    width: 65%;

    @include m.sp() {
      width: 100%;
    }
  }

  .facility-wrapper {
    width: 35%;

    @include m.sp() {
      width: 100%;
    }
  }

  .tabs {
    display: flex;
    justify-content: center;
    height: auto;
    column-gap: 16px;
    border-bottom: 1px solid v.$text-title-color;
    padding: 32px 0;
    @include m.sp() {
      height: auto;
      column-gap: 8px;
      padding: 24px 0;
    }

    .tab {
        font-size: clamp(1rem, -9.125rem + 18vw, 1.125rem);
        word-break: keep-all;
      width: 29%;
      height: 56px;
      border: 1px solid v.$common-element-color;
      transition: background 1s ease-out, color 0.1s ease-out;
      padding: 0 2px;
      @include m.sp() {
        font-size: 0.875rem;
        width: calc(33% - 4px);
        height: 36px;//30%;
      }

      &.-active {
        background: v.$common-element-color;
        color: v.$text-white-color;
      }

      &.-en {
        height: auto;

        :deep(.name) {
          font-size: 1.25rem;
          line-height: 1;
          pointer-events: none;
        }

        &.-active :deep(.name) {
          color: v.$text-white-color;
        }
      }
    }
    /* タブ（一番目だけ幅広に） */
    .tab:first-child {
      font-size: 1.375rem;
      width: 42%;
      @include m.sp() {
        font-size: 1.125rem;
        width: calc(33% - 4px);

      }

      &.-en {
        font-size: 1.125rem;
      }
    }
  }

  .routes {
    /* gridを使って要素内で最も高い要素の高さを確保 */
    display: grid;
    @include m.sp() {
      margin: 24px auto 96px;
    }

    .route {
      grid-area: 1 / 1;
      inset: auto;
      opacity: 0;
      display: none;
      transition: opacity 1s ease-out;

      &.-active {
        opacity: 1;
        display: block;
      }
    }
  }

  .facility-name {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 36px 18px 0;
    @include m.sp() {
      margin: 24px auto 0;
    }
    .title-name {
      font-size: 28px;
      letter-spacing: 4.2px;
      margin-right: 0.8rem;
      @include m.sp() {
        font-size: 1.5rem;
      }
    }
    .sub-title-name {
      letter-spacing: 2.4px;
      @include m.sp() {
        font-size: 1rem;
      }
    }
  }
  .description {
    letter-spacing: 2.4px;
    text-align: left;
    margin: 18px clamp(0px, 0.938vw, 18px) 36px;
    @include m.sp() {
      font-size: 1rem;
      margin: 16px auto 40px;
    }
  }

  .facility-content {
    margin: 8px clamp(8px, 1.458vw, 28px);
    text-align: left;
    @include m.sp() {
      margin: 0 auto;
    }

    .content-title {
      background: v.$bg-list-color;
      font-size: 0.875rem;
      letter-spacing: 2.1px;
      line-height: 44px;
      padding: 0 1.1rem;
      word-break: keep-all;
      @include m.sp() {
        line-height: 32px;
        padding: 6px 8px;
      }
    }

    .list {
      list-style: none;
      padding: 0;
      margin: 8px 0;
      @include m.sp() {
        margin: 4px 0;
      }

      .item {
        padding: 8px 0;
        margin: 0 1rem;
        letter-spacing: 2.1px;
        font-size: 0.875rem;
        line-height: 24px;
      }

      &.line {
        .item + .item {
          border-top: 1px solid v.$border-list-color;
        }
      }
    }
  }

  .address {
    .svg {
      display: inline-block;
      height: 12px;
      width: 12px;
      background: v.$common-element-color;
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: center;
    }
    .postcode {
      > .icon {
        mask-image: url('~/assets/pages/common/IconPostmark.svg');
      }
      > .text {
        margin-left: 5px;
      }
    }
    .address {
      > .icon {
        mask-image: url('~/assets/pages/common/IconLocation.svg');
      }
      > .text {
        margin-left: 5px;
      }
    }
    .contact-number {
      > .icon {
        mask-image: url('~/assets/pages/common/IconTelephone.svg');
      }
      > .text {
        margin-left: 5px;
      }
    }
  }
}
</style>
